import React from 'react';
import { CondensedLarge, ClipboardUtil, ToastUtil } from '@axiom/ui';
import type { Candidate } from '@axiom/validation';

export const CopyEmailsUtil = {
  copyEmailsToClipboard: async (
    rows: Array<Pick<Candidate, 'personalEmail' | 'workEmail'>>
  ) => {
    const emails = rows
      .flatMap(row => [row.personalEmail, row.workEmail])
      .filter(Boolean) as string[];
    await ClipboardUtil.copy({ text: emails.join('; ') });
    ToastUtil.add({
      name: 'copy-email-addresses',
      type: 'info',
      children: (
        <CondensedLarge>
          Email addresses for {rows.length} selected talent copied to clipboard
        </CondensedLarge>
      ),
    });
  },
};
